import { AxiosError } from "axios";

import { InfoModalResSchema } from "@/models/infoModalRes.dto";
import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { ForgotPasswordFormSchema } from "../models";

export abstract class ForgotPassApi {
  static async send(query: ForgotPasswordFormSchema) {
    const response = GbApiRequestService.post(
      "userApi",
      { requestType: "recover", ...query },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );

    const validatedResponse = await withSchemaValidation(
      response,
      InfoModalResSchema,
    );

    const { statusReg, message } = validatedResponse;

    if (statusReg === "fail") {
      throw new AxiosError(message);
    }

    return { statusReg: "success", message } as const;
  }
}
